import { connect } from 'react-redux';
import NewAuction from 'components/auctions/NewAuction';
import {
  clearCreatedAuction,
  createAuction,
  uploadAuction,
  searchFoldersByNumber,
  clearSearchFoldersByNumber,
} from 'data/auctions/Auctions.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = state =>
  ReduxHelper.mapStateWithLookups(
    {
      auctionCreated: state.auctions.auctionCreated,
      creationError: state.auctions.creationError,
      folders: state.auctions.folderSearchResults,
      folderSearchError: state.auctions.folderSearchError,
      folderSearchPending: state.auctions.folderSearchPending,
      lang: state.i18n.locale,
      party: state.app.userParty,
      submitting: state.auctions.creatingAuction,
      user: state.app.user,
    },
    state,
    'applications',
    'auctionStatuses',
    'bidFileTypes',
    'countries',
    'experts',
    'fuelTypes',
    'imitationPartCategories',
    'insurances',
    'memberships',
    'partTypes',
    'partyTypes',
    'regions',
    'usedConditionTypes'
  );

const mapDispatchToProps = dispatch => {
  return {
    clearCreatedAuction: () => dispatch(clearCreatedAuction()),
    onClearSearchFolders: () => dispatch(clearSearchFoldersByNumber()),
    onSearchFolders: searchTerm => dispatch(searchFoldersByNumber(searchTerm)),
    onSubmit: payload => dispatch(createAuction(payload)),
    onUpload: (expertId, insuranceId, garage, file) =>
      dispatch(uploadAuction(expertId, insuranceId, garage, file)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewAuction);
